import React from "react";
import { Box } from "@mui/material";

function CustomInput({ inputType, label, ...rest }) {
  return (
    <div>
      <Box>
        <label style={{ display: "block" }}>{label}</label>
        <input
          type={inputType}
          autoComplete="off"
          className="form-control"
          style={{
            borderWidth: "1px",
            transition: "border-width 0.3s ease",
          }}
          {...rest}
        />
      </Box>
    </div>
  );
}

export default CustomInput;
